<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dLTv83/tc-custom/9783968657844.jpg?1704761761062" alt="This image is the cover for the book Amazing Stories Volume 63, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Amazing Stories Volume 63, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Amazing Stories Volume 63 is a great collection of action short stories from "The Golden Age of Science Fiction". Featured here are five stories by Alan Edward Nourse: "Derelict", "Marley's Chain", "Consignment", "Brightside Crossing, and "Prime Difference".</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alan Edward Nourse
      </h2>
      
      <p class="authorDescription body article">Alan Edward Nourse (August 11, 1928 – July 19, 1992) was an American science fiction writer and physician. He wrote both juvenile and adult science fiction, as well as nonfiction works about medicine and science. His SF works sometimes focused on medicine and/or psionics.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8f367d4c